const { prepend } = require("ramda")

const vehicleColours = [
  "Ash",
  "Black",
  "Blue",
  "Brown",
  "Cream",
  "Custom",
  "Gold",
  "Green",
  "Grey",
  "Indigo",
  "Lemon",
  "Maroon",
  "Orange",
  "Pink",
  "Purple",
  "Red",
  "Silver",
  "Sky Blue",
  "Violet",
  "White",
  "Wine",
  "Yellow",
]

const vehicleColoursDropdown = prepend("", vehicleColours)

module.exports = { vehicleColours, vehicleColoursDropdown }
